export function mountQueryParams(queryParams, acceptNull = false) {
  if (typeof queryParams === 'string') {
    return queryParams;
  }

  if (typeof queryParams !== 'object') {
    throw new Error("O parâmetro 'queryParams' deve ser um objeto ou uma string");
  }

  const queryStrings = Object.entries(queryParams)
    .filter(([, value]) => (
      value !== undefined &&
      value !== '' &&
      (acceptNull || value !== null)
    ))
    .map(([key, value]) => `${key}=${value}`);

  return queryStrings.length > 0 ? `?${queryStrings.join('&')}` : '';
}

export function mountUrl(baseUrl, queryParams) {
  let url = baseUrl;
  if (queryParams) {
    url += `${mountQueryParams(queryParams)}`;
  }
  return url;
}
